module.exports = __webpack_public_path__ + "img/release.5a2338dd.png";